import { keyframes, css } from 'styled-components'

const slideOutDown = keyframes`
  from {
    top: 0;
  }

  to {
    top: 100%;
  }
`

const animation = css`
  animation: ${slideOutDown} 1s cubic-bezier(0.87, 0, 0.13, 1); /* easeInOutExpo */
`

export default animation
